<template>
  <span class="c-product-variants-table__badge" :class="variant">
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'filled'
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/src/utilities/_variables.scss';
@import '~bootstrap/scss/mixins';

.c-product-variants-table {
  &__badge {
    border-radius: 20px;
    border: 1px solid transparent $light;
    padding: 9px 20px;
    font-size: 11px;
    font-weight: $font-weight--bold;
    text-transform: uppercase;

    &.filled {
      background-color: $grey-200;
      border: 1px solid transparent $grey-200;
    }
  }
}
</style>
